export default __webpack_public_path__ + "static/media/takeAPunt.bc9f0aef.png";